import system from './menus/system';
import store from './menus/store';
import event from './menus/event';

export const interfacesMenus = [
    system,
    store,
    event
]